import React, { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';

import Breadcrumbs from './Breadcrumbs.js'

const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function TopAppBar(props) {
	return (
		<GoogleOAuthProvider clientId="408281957818-q99i37vslh6ugah714k7saoirvq51qfn.apps.googleusercontent.com">
		      <AppBar position="fixed">
		        <Toolbar>
		          <IconButton
		            size="large"
		            edge="start"
		            color="inherit"
		            aria-label="menu"
		            sx={{ mr: 2 }}
		          >
		            <MenuIcon />
		          </IconButton>
		          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
		            Vocab App
		            <Breadcrumbs breadcrumbs={props.breadcrumbs} variant="h6" component="div" sx={{ flexGrow: 2 }}/ >
		          </Typography>

		          <Box container justify="flex-end">
		          	{/*<Button color="inherit">Login</Button>*/}
					  <GoogleLogin
							onSuccess={credentialResponse => {
								// console.log(credentialResponse);
							}}
							onError={() => {
								console.log('Login Failed');
							}}
							isSignedIn={true}
						/>
		           </Box>
		        </Toolbar>
		      </AppBar>
			</GoogleOAuthProvider>
	)
}

export default TopAppBar;